import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController
} from "ionic-angular";
import { Http } from "@angular/http";

import config from "../../config/config";
/**
 * Generated class for the ListaUsuariosParceirosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-lista-usuarios-parceiros',
  templateUrl: 'lista-usuarios-parceiros.html',
})
export class ListaUsuariosParceirosPage {
  usuarios = [];
  items = [];
  pes = 1;
  foto = "/perfildefault.jpg";
  usuario: any;
  administrador: any;
  bemVindo: any;
  grupo: any;
  tudo: String = sessionStorage.getItem("usuarios");

  alterado: String = sessionStorage.getItem("alterado");
  consulta: any;
  parcial: string;

  constructor(
    public navCtrl: NavController,
    private _http: Http,
    public loadingCtrl: LoadingController,

    public navParams: NavParams
  ) {}

  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.bemVindo = this.navParams.get("bemVindo");
    this.grupo = this.navParams.get("grupo");

    this.pegarParciais();
    if (this.usuario.grupold == 2) {
      this.administrador = true;
    }
    this.todos(
      "usuario/buscar/nome/ab",
      1,
      "Aguarde carregando todos os sindicalizados"
    );
  }

  todos(env, nu, carregados) {
    let loading = this.loadingCtrl.create({
      content: `${carregados}`
    });
    loading.present();
    // let headers = {''};
    //headers.append 38(“Content-Type”, ‘application/json; charset=utf-8’);

    this._http
      .get(config.urlAPI + env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.items = [];
        this.usuarios = [];
        // console.log(res);
        for (let e = 0; e < 100; e++) {
          if (!res[e].dados) {
            continue;
          }
          // console.log(res[e]);
          if (res[e].dados.foto == null) {
            res[e].dados.foto = "/public/perfildefault.jpg";
          }
          this.usuarios.push(res[e]);
          this.items.push(res[e]);
          loading.dismiss();
        }
      })
      .catch(error => {
        console.log(error);
        loading.dismiss();
      });
  }
  perfil(item) {
    // this.navCtrl
    //   .push(PerfilPage, {
    //     usuario: item,
    //     dados: item.dados,
    //     dependentes: item.dependentes,
    //     grupo: this.grupo,
    //     adm: this.administrador,
    //     bemVindo: this.bemVindo,
    //     usuarioIdAuditoria: this.usuario.id
    //   })
    //   .then(() => {
    //     this.navCtrl.getActive().onDidDismiss(data => {
    //       this.ionViewDidLoad();
    //     });
    //   });
  }
  initializeItems() {
    this.items = [];

    for (var i = 0; i < this.usuarios.length; ++i) {
      var it = this.usuarios[i];
      this.items.push(it);
    }
  }
  buscaespecifica() {
    if (this.consulta) {
      let coluna = "";
      if (this.pes == 1) {
        coluna = "nome";
      }
      if (this.pes == 2) {
        coluna = "cpf";
      }
      this._http
        .get(
          config.urlAPI + "usuario/buscar/" + coluna + "/" + this.consulta,
          {}
        )
        .map(res => res.json())
        .toPromise()
        .then(res => {
          // this.consulta = '';
          for (let t = 0; t < res.length; t++) {
            if (!res[t].dados) {
              continue;
            }
            if (res[t].dados.foto == null) {
              res[t].dados.foto = "/public/perfildefault.jpg";
            }
            this.items.push(res[t]);
          }

          // this.items = res;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
  getItems(ev: any) {
    this.initializeItems();

    const val = ev;
    this.consulta = val;
    if (val.length > 3) {
      // if the value is an empty string don't filter the items
      if (this.pes == 1) {
        if (val && val.trim() != "") {
          this.items = this.items.filter(item => {
            return (
              item.nome
                .toString()
                .toLowerCase()
                .indexOf(val.toLowerCase()) > -1
            );
          });
        } else {
          this.initializeItems();
        }
      }
      if (this.pes == 2) {
        if (val && val.trim() != "") {
          this.items = this.items.filter(item => {
            return (
              item.cpf
                .toString()
                .toLowerCase()
                .indexOf(val.toLowerCase()) > -1
            );
          });
        } else {
          this.initializeItems();
        }
      }
      if (this.pes == 3) {
        if (val && val.trim() != "") {
          this.items = this.items.filter(item => {
            return (
              item.intereses
                .toString()
                .toLowerCase()
                .indexOf(val.toLowerCase()) > -1
            );
          });
          // console.log(this.items);
        } else {
          this.initializeItems();
        }
      }

      ev = "";
    }
  }
  filtrofunc(pes) {
    // console.log(pes);
  }

  pegarParciais() {
    this._http
      .get(config.urlAPI + "usuario/parciais", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.parcial = res;
      })
      .catch(error => {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/lista-usuarios-parceiros/lista-usuarios-parceiros.ts